import {useModal} from "../../../../hooks";
import {useUser} from "../../../../util/userContext/UserContext";
import {useCreateAdjustmentCode} from "./hooks/useCreateAdjustmentBarcode";
import {useCreateAdjustment} from "./hooks/useCreateAdjustment";
import {useUploadAdjustmentExcel} from "./hooks/useUploadAdjustmentExcel";
import React, {useEffect, useState} from "react";
import {AdjustmentCreateType} from "./interface";
import {adjustmentCreateInit} from "./state";
import {SubmitHandler, useForm, useWatch} from "react-hook-form";
import ScanBarcodeInner from "../../../../components/common/modal/inner/ScanBarcodeInner";
import SearchInventoryInner from "../../../../components/common/modal/inner/SearchInventoryInner";
import moment from "moment";
import FileUploadNoText from "../../../../components/common/fileUpload/fileUploadNoText/FileUploadNoText";
import EmptyTableRow from "../../../common/EmptyTableRow";
import {InvDetailType} from "../../inv/detail/interface";
import {useLocation} from "react-router-dom";
import InputNumberUc from "../../../../components/common/number/InputNumberUc";
import DisplayNumber from "../../../../components/common/number/DisplayNumber";

export default function AdjustmentCreate() {
    const {state} = useLocation() as { state: { invDetail: InvDetailType } };
    const invDetail = state?.invDetail;
    const {handleModal} = useModal();

    const {user} = useUser();
    const {data: adjustmentCode} = useCreateAdjustmentCode()
    const {mutate: mutateCreateAdjustment} = useCreateAdjustment()
    const {mutateAsync: mutateAsyncUploadAdjustmentExcel} = useUploadAdjustmentExcel()

    const [createData, setCreateData] = useState<AdjustmentCreateType>((() => ({
        ...adjustmentCreateInit,
        changeAt: moment().format("YYYY-MM-DD"),
    }))())

    const {register, handleSubmit, getValues, control, setValue, watch} = useForm({
        defaultValues: createData,
    });

    const watchCreateData = {
        ...createData,
        ...useWatch<AdjustmentCreateType>({control}),
    };

    useEffect(() => {
        console.log("invDetail : ", invDetail);
        console.log("createData : ", createData);

        if (invDetail) {
            setValue("createEachAdjustmentReqList", [{
                ...invDetail,
                changeAmount: 1,
            }]);
        }
    }, []);

    const onSubmit: SubmitHandler<AdjustmentCreateType> = (submitData) => {
        if (getValues("createEachAdjustmentReqList").length === 0) {
            handleModal({
                isOpen: true,
                contents: "출고 품목을 추가해주세요.",
                type: "alert"
            })
        } else {
            mutateCreateAdjustment({...submitData, code: adjustmentCode})
        }
    };

    const btnImportExcel = (file: File[]) => {
        if (file.length === 0) {
            handleModal({
                isOpen: true,
                contents: "파일을 선택해주세요.",
                type: "alert"
            })
        } else {
            const fd = new FormData()
            fd.append("excelFile", file.at(0) as File)

            mutateAsyncUploadAdjustmentExcel(fd).then((res: any) => {
                if (res.data.code === "0000") {
                    const list = res.data.result

                    if (
                        getValues("createEachAdjustmentReqList").some(el => list.map((el2: any) => el2.inventoryId).includes(el.inventoryId))
                    ) {
                        handleModal({
                            isOpen: true,
                            contents: "중복된 품목은 추가할 수 없습니다.",
                            type: "alert",
                        });
                    } else {
                        setValue("createEachAdjustmentReqList", [...getValues("createEachAdjustmentReqList"), ...list.map((el: any) => ({
                            ...el,
                        }))])
                    }
                } else {
                    handleModal({
                        isOpen: true,
                        contents: res.data.message ?? res.data.msg,
                        type: "alert",
                    });
                }
            })
        }
    }

    const removeItem = (index: number) => {
        setValue("createEachAdjustmentReqList", getValues("createEachAdjustmentReqList").filter((_, i) => i !== index));
    };

    const btnShowScanBarcodeInterface = () => {
        handleModal({
            isOpen: true,
            contents: <ScanBarcodeInner
                value={getValues("createEachAdjustmentReqList")}
                setValue={(data) => setValue("createEachAdjustmentReqList", data)}
            />,
            type: "",
            title: "바코드 스캔"
        });
    }

    const btnAdd = () => {
        handleModal({
            isOpen: true,
            contents: <SearchInventoryInner
                confirmCallback={(item) => {
                    setValue("createEachAdjustmentReqList", [...getValues("createEachAdjustmentReqList"), {
                        ...item,
                        changeAmount: 1
                    }])
                }}
                modalDepth={1}
            />,
            type: "",
            title: "재고 조회",
            modalSize: "xl",
        });
    }

    return <div className="content_wrap">
        <div className="fiter_top">
            <h3 className="filter_heading">조정 등록</h3>
            <div className="filter_toolbar">
                {/* NOTE: 목록 버튼이 필요 없어 보여서 삭제 */}
                {/*<button className="btn btn-outline-primary w-100px h-38px">*/}
                {/*    <img src={process.env.PUBLIC_URL + "/assets/images/icon_hamburger_btn.png"} alt=""/>목록*/}
                {/*</button>*/}
                <button className="btn btn-primary w-100px h-38px" onClick={handleSubmit(onSubmit)}>등록</button>
            </div>
        </div>
        <h5 className="subheading">조정 정보</h5>
        <table className="table table-bordered my_table">
            <tbody>
            <tr>
                <th style={{width: "16.66%"}}>입고번호</th>
                <td colSpan={3}>{adjustmentCode ?? ""}</td>
            </tr>
            <tr>
                <th style={{width: "16.66%"}}>생성자</th>
                <td style={{width: "33.3%"}}>{user?.userName ?? ""}</td>
                <th style={{width: "16.66%"}}>생성일자</th>
                <td>{moment().format("YYYY-MM-DD")}</td>
            </tr>
            <tr>
                <th>메모</th>
                <td className="p-4px" colSpan={3}>
                    <input type="text" className="form-control"
                           value={watchCreateData.memo}
                           {...register("memo")}
                    />
                </td>
            </tr>
            </tbody>
        </table>
        <div className="table_top mb-10px align-items-end">
            <h6 className="table_stats">조정 품목</h6>
            <div className="table_toolbar">
                <FileUploadNoText
                    addFileCallback={(file: File[]) => btnImportExcel(file)}
                    customRenderer={(onClick: any, disabled: any) =>
                        <button className="btn btn-outline-dark w-150px px-0"
                                onClick={onClick}
                                disabled={disabled}><img
                            src={process.env.PUBLIC_URL + "/assets/images/icon_import.png"} alt=""/>엑셀 가져오기
                        </button>

                    }
                    accept={".xlsx, .xls"}
                />
                <button className="btn btn-primary w-100px px-0 ms-40px" onClick={btnShowScanBarcodeInterface}>바코드 스캔
                </button>
                <button className="btn btn-dark w-100px" onClick={btnAdd}>추가</button>
            </div>
        </div>

        <table className="table table-bordered my_table mb-0">
            <thead>
            <tr>
                <th style={{width: "5%"}}></th>
                <th style={{width: "10.06%"}}>벤더</th>
                <th style={{width: "10.06%"}}>카테고리</th>
                <th style={{width: "24.5%"}}>품목</th>
                <th style={{width: "13.83%"}}>규격</th>
                <th style={{width: "13.83%"}}>단위</th>
                <th>재고</th>
                <th style={{width: "13.83%"}}>조정 수량</th>
            </tr>
            </thead>
            <tbody>
            {watchCreateData.createEachAdjustmentReqList.length !== 0
                ? watchCreateData.createEachAdjustmentReqList.map((el, idx) =>
                    <tr>
                        <td className="text-center">
                            <button className="btn btn-link p-0" onClick={() => removeItem(idx)}>
                                <img src={process.env.PUBLIC_URL + "/assets/images/icon_btn_delete.png"}
                                     alt=""/>
                            </button>
                        </td>
                        <td className="text-center">{el.vendor}</td>
                        <td className="text-center">{el.category}</td>
                        <td className="text-center">{el.newTxtNmItem}</td>
                        <td className="text-center">{el.newTxtStndItem}</td>
                        <td className="text-center">{el.inventoryUnit}</td>
                        <td className="text-center"><DisplayNumber value={el.inventoryAmount ?? 0}/></td>
                        <td className="p-4px">
                            <InputNumberUc control={control} name={`createEachAdjustmentReqList.${idx}.changeAmount`}/>
                            {/*<input type="text"
                                   className="form-control text-center"
                                   value={el.changeAmount}
                                   min={0}
                                   {...register(`createEachAdjustmentReqList.${idx}.changeAmount`)}
                            />*/}
                        </td>
                    </tr>
                )
                : <EmptyTableRow colSpan={7} msg={"조정 품목을 추가해주세요."}/>
            }

            <tr className="blue">
                <td className="text-center" colSpan={5}>품목 수</td>
                <td className="text-end"></td>
                <td className="text-center">총 수량</td>
                <td className="text-center">
                    {isNaN(watchCreateData.createEachAdjustmentReqList.reduce((acc, cur) => acc + Number(cur.changeAmount), 0))
                        ? <>-</>
                        : <span
                            className={watchCreateData.createEachAdjustmentReqList.reduce((acc, cur) => acc + Number(cur.changeAmount), 0) < 0 ? "required" : "requiredBlue"}>
                        {watchCreateData.createEachAdjustmentReqList.reduce((acc, cur) => acc + Number(cur.changeAmount), 0) > 0 && <></>}
                            <DisplayNumber
                                value={watchCreateData.createEachAdjustmentReqList.reduce((acc, cur) => acc + Number(cur.changeAmount), 0)}/>
                    </span>
                    }
                </td>
                {/*
                <td className="text-end">
                    {isNaN(watchCreateData.createEachAdjustmentReqList.reduce((acc, cur) => acc + Number((cur.changeAmount as number) - (cur.inventoryAmount as number)), 0))
                        ? <>-</>
                        : <>
                            {watchCreateData.createEachAdjustmentReqList.reduce((acc, cur) => acc + Number((cur.changeAmount as number) - (cur.inventoryAmount as number)), 0) > 0 &&
                                <span className="required">+</span>}
                            {watchCreateData.createEachAdjustmentReqList.reduce((acc, cur) => acc + Number((cur.changeAmount as number) - (cur.inventoryAmount as number)), 0)}
                        </>
                    }
                </td>
                * */}
            </tr>
            </tbody>
        </table>
    </div>
}